import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { all } from 'rsvp'
import { defaultProductForSubscriptionType } from 'teacher-ui-client/utils/products'
import type SessionService from 'teacher-ui-client/services/session'
import type RouterService from '@ember/routing/router-service'
import type Store from '@ember-data/store'
import type Transition from '@ember/routing/transition'
import type Controller from '@ember/controller'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type Student from 'teacher-ui-client/models/student'
import type SchoolClass from 'teacher-ui-client/models/school-class'

export default class ManageProgressRoute extends Route {
  @service session!: SessionService

  @service store!: Store

  @service router!: RouterService

  queryParams = {
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
    textFilter: {
      replace: true,
    },
    selected: {
      replace: true,
    },
    picked: {
      replace: true,
    },
    product: {
      replace: true,
    },
  }

  async model() {
    const { currentTeacher } = this.session

    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const isSubco = currentTeacher.subcoFor(subscriptionType)

    let studentQuery
    if (isSubco) {
      studentQuery = { include: 'school-classes' }
    } else {
      const schoolClasses = currentTeacher.schoolClasses.filter((sc) => sc.subscriptionType === subscriptionType)
      studentQuery = {
        include: 'school-classes',
        filter: { 'school-classes': { id: schoolClasses.map((sc) => sc.id).join(',') } },
      }
    }
    // @ts-expect-error - include types not correct
    const studentsPromise = this.store.query<Student>('student', studentQuery)
    const allSchoolClassesPromise = this.store.query<SchoolClass>('school-class', {
      // @ts-expect-error - include types not correct
      include: 'teachers',
    })

    // Fetch all promises in parallel
    const [students, allSchoolClasses] = await all([studentsPromise, allSchoolClassesPromise])

    const allocatedStudents = students.filter((student) => student.isAllocatedForSubscriptionType(subscriptionType))

    return {
      allocatedStudents,
      allSchoolClasses: allSchoolClasses.filter((sc) => sc.subscriptionType === subscriptionType),
      subscriptionType,
      currentTeacherId: currentTeacher.id,
    }
  }

  setupController(
    controller: Controller & { product?: string; resetGroupFilterOption: () => unknown },
    model: Record<string, unknown> & { subscriptionType: SubscriptionType },
    transition: Transition,
  ) {
    super.setupController(controller, model, transition)

    if (!controller.product) {
      void this.router.transitionTo({
        queryParams: { product: defaultProductForSubscriptionType(model.subscriptionType) },
      })
    }
  }
}
